<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<h2 class="text-primary" style="margin-bottom: 0px;">
					<i class="fas fa-user" /> Usuários
				</h2>
				<small class="text-muted">Configurações dos seus usuários.</small>
			</div>

			<div class="col-md-6 text-right">
				<button
					class="btn btn-success"
					style="margin-left:5px"
					@click="selectUser()"
				>
					<i class="fas fa-plus" /> Adicionar Usuário
				</button>
			</div>
		</div>

		<br />

		<hr />

		<div class="row">
			<div class="col-md-4">
				<text-input :alias="'Pesquisar'" v-model="searchForm.name"></text-input>
			</div>
			<div class="col-md-4 d-flex align-items-end">
				<div class="form-group">
					<button type="button" class="btn btn-sm btn-primary" @click="select">
						<i class="fas fa-search" /> Pesquisar
					</button>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<b-form-checkbox
					v-model="searchForm.status"
					unchecked-value="0"
					value="1"
					name="check-button"
					switch
					@change="select"
					>Exibir somente Ativos</b-form-checkbox
				>
			</div>
		</div>

		<br />

		<div class="row">
			<div class="col-md-12">
				<table-paginator :data="users" @pagechange="select($event)">
					<table class="customTable table table-hover">
						<tr>
							<th>Nome</th>
							<th>Email</th>
							<th>Status</th>
						</tr>
						<tbody>
							<tr
								v-for="(row, index) in users.data"
								@click="selectUser(row)"
								style="cursor:pointer"
								:class="[{ 'text-muted': row.status == 0 }]"
								:key="index"
							>
								<td>
									<avatar
										inline
										color="#fff"
										:size="30"
										:username="row.name"
										:initials="getInitial(row.name)"
									></avatar>
									<span class="ml-3">{{ row.name }}</span>
									<span
										v-if="row.is_master_user == 1"
										class="badge badge-primary ml-2"
										>Proprietário da conta</span
									>
									<span
										v-if="row.is_admin_user == 1"
										class="badge badge-info  ml-2"
										>Administrador</span
									>
								</td>
								<td>{{ row.email }}</td>
								<td>
									<span
										:class="['badge', 'text-white', status[row.status].class]"
										style="line-height:1.2"
										>{{ status[row.status].text }}</span
									>
								</td>
							</tr>
						</tbody>
					</table>
				</table-paginator>
			</div>
		</div>

		<error-handler :error="error" />
 
		<user-form @stored='select()' ref="UserForm" />
	</div>
</template>

<script>
	import Avatar from "vue-avatar";
 	import TablePaginator from "./../components/sections/TablePaginator.vue";
	import UserForm from '../components/user/forms/UserForm.vue';

	export default {
		components: {
			Avatar,
 			TablePaginator,
			UserForm
		},

		data: function () {
			return {
				users: {},

				searchForm: {
					name: null,
					status: 1
				},

				status: {
					"1": {
						text: "Ativo",
						class: "badge-success"
					},

					"0": {
						text: "Inativo",
						class: "badge-danger"
					}
				},

				error: null
			};
		},

		created() {
			axios
				.post("api/user/select", this.searchForm)
				.then(response => {
					this.users = response.data;

					this.$store.commit("pageHasLoaded");
				})
				.catch(error => {
					this.error = error;
					this.$store.commit("pageHasLoadedWithError", { error: error });
				});
		},

		computed: {
			userPermissions() {
				const permission = this.$store.state.user_permissions.filter((row) => {
					return (row.permission == 'productIndex')
				})[0]

				return (permission.has_permission == 1)
			}
		},

		methods: {
			getInitial(value) {
				return value.slice(0, 1);
			},

			storeUser(user = null) {
				this.$refs.form.open(user);
			},

			select(page = 1) {
				this.$store.commit("showLoading");

				axios
					.post("api/user/select?page=" + page, this.searchForm)
					.then(response => {
						this.users = response.data;

						this.$store.commit("hideLoading");
					})
					.catch(error => {
						this.error = error;

						this.$store.commit("hideLoading");
					});
			},
			selectUser(user = null) {
				this.$refs.UserForm.open(user)
			}
		}
	};
</script>

